/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Preference } from 'src/app/model/preference';
import { PreferenceProvider } from 'src/app/providers';

@Component({
  selector: 'app-update-preference-modal',
  templateUrl: './update-preference.modal.html',
  styleUrls: ['./update-preference.modal.scss']
})

export class UpdatePreferenceModal implements OnInit, OnDestroy {
  subject: Subject<any>;
  subscription: any;
  confirmationModal: BsModalRef;
  preference: Preference = new Preference();
  name: string;
  newFilter = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private preferenceProvider: PreferenceProvider,
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onSubmit(): void {

    const newPreference = JSON.parse(JSON.stringify(this.preference));
    newPreference.ID = null;
    newPreference.NAME = this.name;

    this.preferenceProvider.savePreference(newPreference)
      .subscribe(
        data => {
          if (data.success) {
            this.bsModalRef.hide();
            this.subject.next({
              ACTION: 'CREATE_NEW',
              PREFERENCE: Preference.parse(data.result)
            });
            this.subject.complete();
          }
        });
  }

  onConfirm(): void {
    this.preferenceProvider.savePreference(this.preference)
      .subscribe(
        data => {
          if (data.success) {
            this.bsModalRef.hide();
            this.subject.next({
              ACTION: 'UPDATE',
              PREFERENCE: Preference.parse(data.result)
            });
            this.subject.complete();
          }
        });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next({
      ACTION: 'CANCEL'
    });
    this.subject.complete();
  }

  onNewFilter(): void {
    // this.newFilter = true;
    this.newFilter = true;
  }
}
